"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Folder;

var _Folder = require("@adobe/react-spectrum-workflow/dist/Folder.js");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Folder(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Folder.A4uFolder, null));
}